import { render, staticRenderFns } from "./validSetDialog.vue?vue&type=template&id=06ff53b7&scoped=true&"
import script from "./validSetDialog.vue?vue&type=script&lang=js&"
export * from "./validSetDialog.vue?vue&type=script&lang=js&"
import style0 from "./validSetDialog.vue?vue&type=style&index=0&id=06ff53b7&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ff53b7",
  null
  
)

export default component.exports